module.exports = __webpack_public_path__ + "static/media/img_rlzy.975d0ad5.png";